import { useNavigate, useLocation } from "react-router-dom";
import market from "../css/market.module.scss"
import confirm from "../css/confirm.module.css";

export type MessageParam = {
    message: string,
    displayButton: boolean
}

export const Message = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const messageParam = location.state as MessageParam;

    return (
        <>
            <section className={confirm.OutSideArea}>
                <div className={confirm.InSideArea}>
                    <h3>{messageParam.message}</h3>
                </div>
            </section>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    {messageParam.displayButton ?
                        <div className={market.marketFooterArea}>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton}>戻る</button>
                            <button className={market.marketButton} onClick={(e) => { navigate("/MyPage") }}>マイページ</button>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton}>進む</button>
                        </div>
                        :
                        <br />
                    }
                </div>
            </section>
        </>
    );
}  